import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { ResetScroll } from 'teacher-ui-client/modifiers/reset-scroll'

export const ReportingUiScopeMathseedsPrimePage: TOC<unknown> = <template>
  <div class="w-full" {{ResetScroll onSetup=true onRouterChange=true}}>
    {{outlet}}
  </div>
</template>

export default RouteTemplate(ReportingUiScopeMathseedsPrimePage)
